import LandingPage from '../views/LandingPage'
import Login from '../views/Login'
import Register from '../views/Register'
import RegisterSuccess from '../views/RegisterSuccess'
import Disconnection from '../views/Disconnection'
import Code404 from '../views/response/Code404'
import Code503 from '../views/response/Code503'
import ForgottenPassword from '../views/ForgottenPassword'
import ForgottenPasswordSuccess from '../views/ForgottenPasswordSuccess'
import ChangePassword from '../views/ChangePassword'
import ChangePasswordSuccess from '../views/ChangePasswordSuccess'
import Activation from '../views/Activation'
import LegalNotice from '../views/LegalNotices'

const routes = [
    {
        path: '/accueil',
        meta: {
            layout: 'standard',
            sessionCheck: true
        },
        component: LandingPage,
        name: 'home'
    },
    {
        path: '/', redirect: to => {
            var hostname = window.location.hostname;
            if (hostname.indexOf('reglement') >= 0) {
                return '/accueil'
            } else {
                return '/connexion'
            }
        },
        meta: {
            sessionCheck: false
        },
        name: 'base'
    },
    {
        path: '/connexion',
        meta: {
            sessionCheck: true
        },
        component: Login,
        name: 'login'
    },
    {
        path: '/inscription',
        meta: {
            sessionCheck: false
        },
        component: Register,
        name: 'register'
    },
    {
        path: '/inscription-valide',
        meta: {
            sessionCheck: false
        },
        component: RegisterSuccess,
        name: 'register-success'
    },
    {
        path: '/activation/:token',
        meta: {
            sessionCheck: false
        },
        component: Activation,
        name: 'activate'
    },
    {
        path: '/mot-de-passe-oublie',
        meta: {
            sessionCheck: false
        },
        component: ForgottenPassword,
        name: 'forgotten-password'
    },
    {
        path: '/mot-de-passe-oublie-valide',
        meta: {
            sessionCheck: false
        },
        component: ForgottenPasswordSuccess,
        name: 'forgotten-password-success'
    },
    {
        path: '/change-mot-de-passe/:token',
        meta: {
            sessionCheck: false
        },
        component: ChangePassword,
        name: 'change-password'
    },
    {
        path: '/change-mot-de-passe-valide',
        meta: {
            sessionCheck: false
        },
        component: ChangePasswordSuccess,
        name: 'change-password-success'
    },
    {
        path: '/mentions-legales',
        meta: {
            sessionCheck: false
        },
        component: LegalNotice,
        name: 'legal-notice'
    },
    {
        path: '/deconnexion',
        meta: {
            sessionCheck: false
        },
        component: Disconnection,
        name: 'disconnect'
    },
    {
        path: '/503',
        meta: {
            sessionCheck: false
        },
        component: Code503,
        name: 'maintenance'
    },
    {
        path: '/404',
        meta: {
            sessionCheck: false
        },
        component: Code404,
        name: 'notFound'
    },
    {
        path: '*',
        meta: {
            sessionCheck: false
        },
        redirect: '/404'
    }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js